;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { TOUR_OVERLAY_GROUPS } from "@/features/onboarding-tours/orchestrator/tour-overlay-groups";
import { tourStep } from "@/features/onboarding-tours/orchestrator/tour-step-builder";
import {
	TOUR_TARGETS,
	tourSelector,
} from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { defineTour } from "@/features/onboarding-tours/registry/define-tour";
import { TourCategory } from "@/features/onboarding-tours/types/tour-category";

const dataProviderCardTarget = tourSelector(TOUR_TARGETS.dataProviderCard);
const dataProviderDeleteTarget = tourSelector(TOUR_TARGETS.dataProviderDelete);
const dataProviderDeleteSubmitTarget = tourSelector(
	TOUR_TARGETS.dataProviderDeleteSubmit,
);

export const deleteDataProviderTour = defineTour({
	buildSteps: () => [
		tourStep({
			content: "Open the Data Providers section to manage connections.",
			data: {
				watchTargetClick: {
					selector: dataProviderDeleteTarget,
					stepIndex: 2,
				},
			},
			placement: "bottom",
			scrollBefore: tourSelector(TOUR_TARGETS.dataProvidersSection),
			spotlightPadding: 12,
			target: tourSelector(TOUR_TARGETS.dataProvidersSection),
			title: "Data providers",
		}),
		tourStep({
			content:
				"Use the delete control on the provider you want to remove from this workspace.",
			data: {
				advanceOnNext: {
					effect: "openDataProviderDelete",
					stepIndex: 2,
				},
				watchTargetClick: {
					selector: dataProviderDeleteTarget,
					stepIndex: 2,
				},
			},
			placement: "right",
			scrollBefore: dataProviderCardTarget,
			spotlightPadding: 12,
			target: dataProviderCardTarget,
			title: "Choose a provider",
		}),
		tourStep({
			content:
				"Click Delete to permanently remove this provider from your workspace.",
			data: {
				overlayGroup: TOUR_OVERLAY_GROUPS.deleteDataProvider,
			},
			effect: "openDataProviderDelete",
			hideOverlay: true,
			placement: "top",
			target: dataProviderDeleteSubmitTarget,
			title: "Confirm deletion",
			waitForTarget: true,
		}),
	],
	catalog: {},
	category: TourCategory.dataIntegrations,
	description:
		"Remove a connected integration when you no longer need it in this workspace.",
	eligibility: { requiresDataProviderDelete: true },
	id: "delete-data-provider",
	launch: {
		startRoute: ({ workspaceId }) => `/${workspaceId}/settings?tab=workspace`,
	},
	tags: ["data provider", "delete", "remove", "disconnect"],
	title: "Delete a data provider",
});

export const manualSyncPortfolioTour = defineTour({
	buildSteps: () => [
		tourStep({
			content:
				"Trigger a sync when you need fresh portfolio data without waiting for the schedule.",
			placement: "bottom",
			target: tourSelector(TOUR_TARGETS.portfolioManualSyncButton),
			title: "Manual sync",
		}),
	],
	catalog: { lockedLabel: "Upgrade to unlock" },
	category: TourCategory.dataIntegrations,
	description:
		"Refresh units and properties from your connected provider on demand.",
	eligibility: { requiresFullProductAccess: true },
	id: "manual-sync-portfolio",
	launch: {
		startRoute: ({ workspaceId }) => `/${workspaceId}/settings?tab=portfolio`,
	},
	tags: ["sync", "portfolio", "manual", "data"],
	title: "Manual portfolio sync",
});
